import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-radio-group',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './radio-group.component.html',
  styleUrl: './radio-group.component.scss',
})
export class RadioGroupComponent implements OnInit, OnChanges {
  @Input() names: { id: string; name: string }[] = [];
  @Input() id: string = "";
  @Output() selecteditem = new EventEmitter<{ id: string; value: string }>();
  @Input() existingValue: string = '';

  @Input() keyRequired = false;
  @Input() checkValidation: boolean = false;
  @Output() requiredKey = new EventEmitter<{ id: string; required: boolean ,field?:string}>();

  selectedValue: string = ''; // will store Y or N
  showRequiredError: boolean = false;

  ngOnInit() {
    if ((this.names as any).list) {
      this.names = (this.names as any).list;
    }

    if (this.existingValue) {
      this.selectedValue = this.existingValue; // should be 'Y' or 'N'
      console.log(this.existingValue);
      
      this.selecteditem.emit({ id: this.id, value: this.existingValue });
    }

    if (this.keyRequired) {
      setTimeout(() => {
        this.requiredKey.emit({ id: this.id, required: this.keyRequired });
      }, 300);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['checkValidation'] && changes['checkValidation'].currentValue === true) {
      if (this.keyRequired && !this.selectedValue) {
        this.showRequiredError = true;
      }
    }
    if (changes['existingValue']) {
      if (this.existingValue) {
        this.selectedValue = this.existingValue; // should be 'Y' or 'N'
        console.log(this.existingValue);
        
        this.selecteditem.emit({ id: this.id, value: this.existingValue });
      }
    }
  }

  onSelectionChange(value:string) {
    this.selectedValue = value;
    this.selecteditem.emit({ id: this.id, value });

    if (this.keyRequired) {
      this.showRequiredError = !this.selectedValue;
    }
  }

  // 🟢 Handles showing Enable/Disable if name is "Y"/"N"
  displayName(item: { id: string; name: string }): string {
    if (item.id === 'Y' && (item.name === 'Y' || item.name === 'Yes')) return 'Enable';
    if (item.id === 'N' && (item.name === 'N' || item.name === 'No')) return 'Disable';
    return item.name; // fallback (e.g. already Enable/Disable)
  }
}
